var map = {
	"./collection.js": "./src/config-builders/project/reducers/collection.js",
	"./feature.js": "./src/config-builders/project/reducers/feature.js",
	"./scope.js": "./src/config-builders/project/reducers/scope.js",
	"./selector.js": "./src/config-builders/project/reducers/selector.js"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 138;



//////////////////
// WEBPACK FOOTER
// ./src/config-builders/project/reducers nonrecursive \.js$
// module id = 138
// module chunks = 0